import React from "react"
import FindChatRecord from "./find-chat-recoed-screen"
import { PageRoot } from "~screens/page-root"



const FindChatRecordScreen: React.FC<any> = (props) => {
  return (
    <PageRoot>
      <FindChatRecord {...props}/>
    </PageRoot>
  )
}

export default FindChatRecordScreen
